<div class="header">
  <div>
    <h2>Departments</h2>
    <p>Manage and categorize your organizational departments</p>
  </div>
  <button class="add-btn" (click)="toggleModal('add')">
    <img src="assets/images/PlusIcon.svg" alt="" />Add New Department
  </button>
</div>

<div class="rp-body">
  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Department</th>
          <th>Sub Departments</th>
          <th class="text-right pr-4">Action</th>
        </tr>
      <tbody *ngIf="loading || showSkeleton">
        <tr *ngFor="let row of skeletonRows">
          <td *ngFor="let col of skeletonCols">
            <div class="skeleton-cell"></div>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="!loading && !showSkeleton">
        @for (item of departments; track item.id) {
        <tr>
          <td class="dept-title">{{ item.department_name }}</td>
          <td>
            <div class="sub-dep-container">
              <span class="sub-dep-badge" *ngFor="let sub of getSubDepartments(item.sub_department_name)">{{
                sub
                }}</span>
            </div>
          </td>
          <td class="text-right icon-btns">
            <button class="btn-icon" (click)="openEditModal(item)">
              <img src="assets/images/editIcon.svg" alt="Edit" />
            </button>
            <button class="btn-icon" (click)="openDeleteModal(item)">
              <img src="assets/images/trashIcon.svg" alt="Delete" />
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Add/Edit Modal -->
<app-add-popup *ngIf="showAddEditModal" [title]="isEditMode ? 'Edit Department' : 'Add New Department'" [subtitle]="
    isEditMode
      ? 'Update the title or description to modify this department'
      : 'Create departments to group teams and streamline your company’s operations.'
  " [iconPath]="
    isEditMode ? 'assets/images/editPopup.png' : 'assets/images/addPopup.png'
  " (close)="toggleModal('add')">
  <form [formGroup]="departmentForm" (ngSubmit)="onSave()">
    <div class="input-group">
      <label>Department Title*</label>
      <input type="text" formControlName="title" placeholder="Write here" />
    </div>

    <div class="input-group">
      <label>Description*</label>
      <textarea formControlName="subDeps" placeholder="Write description here"></textarea>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="toggleModal('add')">
        Cancel
      </button>
      <button type="submit" class="btn-save" [disabled]="departmentForm.invalid">
        <span> <img src="assets/images/savePopup.svg" alt="" /></span>
        {{ isEditMode ? "Update" : "Save" }}
      </button>
    </div>
  </form>
</app-add-popup>

<!-- Delete Confirmation Modal -->
<app-add-popup *ngIf="showDeleteModal" title="Delete Department"
  subtitle="Are you sure you want to delete this department? This action cannot be undone."
  iconPath="assets/images/deleteicon.svg" (close)="toggleModal('delete')">
  <div class="modal-footer justify-center">
    <button type="button" class="btn-cancel" (click)="toggleModal('delete')">
      Cancel
    </button>
    <button type="button" class="btn-save" (click)="confirmDelete()">
      <span> <fa-icon [icon]="faTrashCan"></fa-icon></span>Delete
    </button>
  </div>
</app-add-popup>